import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Berita = () => {
  const [berita, setBerita] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState([]);
  const cardRef = useRef([]);

  /* ================= FORMAT TANGGAL ================= */
  const formatTanggal = (tanggal) => {
    if (!tanggal) return "-";
    const date = new Date(tanggal);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    return `${String(date.getDate()).padStart(2, "0")} ${
      monthNames[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  /* ================= MEDIA HANDLER (ARRAY SAFE) ================= */
  const getMedia = (item) => {
    if (!item) return null;

    // ambil media pertama
    const gambar =
      Array.isArray(item.gambar) && item.gambar.length > 0
        ? item.gambar[0]
        : null;

    const link =
      Array.isArray(item.link) && typeof item.link[0] === "string"
        ? item.link[0].trim()
        : "";

    /* ===== YOUTUBE ===== */
    if (link && link.includes("youtu")) {
      let videoId = null;

      try {
        if (link.includes("youtu.be")) {
          videoId = link.split("youtu.be/")[1]?.split("?")[0];
        } else {
          const url = new URL(link);
          videoId = new URLSearchParams(url.search).get("v");
        }
      } catch (err) {
        videoId = null;
      }

      if (videoId) {
        return (
          <iframe
            src={`https://www.youtube.com/embed/${videoId}`}
            className="absolute inset-0 w-full h-full"
            allowFullScreen
            title={item.judul}
          />
        );
      }
    }

    /* ===== MEDIA BACKEND ===== */
    if (gambar && gambar.filename) {
      const mediaUrl = `${process.env.REACT_APP_API_URL}api/berita/media/${gambar.filename}`;

      if (gambar.mimetype?.startsWith("video")) {
        return (
          <video
            controls
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src={mediaUrl} type={gambar.mimetype} />
          </video>
        );
      }

      if (gambar.mimetype?.startsWith("image")) {
        return (
          <img
            src={mediaUrl}
            alt={item.judul}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        );
      }
    }

    /* ===== FALLBACK ===== */
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-gray-200 dark:bg-slate-700">
        <span className="text-gray-500 dark:text-gray-300 text-sm">
          Media tidak tersedia
        </span>
      </div>
    );
  };

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}api/berita`)
      .then((res) => res.json())
      .then((data) => {
        setBerita(data.slice(0, 6));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  /* ================= ANIMATION ================= */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.index;
          if (entry.isIntersecting) {
            setVisible((prev) =>
              prev.includes(index) ? prev : [...prev, index],
            );
          }
        });
      },
      { threshold: 0.2 },
    );

    cardRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [berita]);

  if (loading)
    return <div className="text-center py-20 text-gray-500">Loading...</div>;

  return (
    <section className="py-16 bg-gradient-to-b from-purple-200 to-purple-300 dark:from-slate-900 dark:to-slate-800">
      <h1 className="text-center text-4xl font-extrabold mb-12">
        Berita Terbaru
      </h1>

      <div className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {berita.map((item, index) => (
            <div
              key={item._id}
              ref={(el) => (cardRef.current[index] = el)}
              data-index={index}
              className={`
                rounded-2xl overflow-hidden shadow-xl
                bg-white dark:bg-slate-800
                transition-all duration-700
                ${
                  visible.includes(String(index))
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10"
                }
              `}
            >
              {/* MEDIA */}
              <div className="relative w-full aspect-video">
                {getMedia(item)}
              </div>

              {/* CONTENT */}
              <div className="p-5">
                <p className="text-xs text-gray-500 mb-2">
                  {formatTanggal(item.tanggal)}
                </p>

                <h2 className="font-bold text-lg mb-3 line-clamp-2">
                  {item.judul}
                </h2>

                <Link to={`/berita/${item._id}`}>
                  <button className="w-full py-2 rounded-full bg-yellow-400 hover:bg-yellow-300 font-semibold transition">
                    Baca Selengkapnya
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* BUTTON ALL */}
        <div className="flex justify-center mt-14">
          <Link to="/berita">
            <button className="px-10 py-3 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-semibold transition">
              Baca Semua Berita
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Berita;
